import styled from 'styled-components'
import { breakpoints, contentWidth } from '@/theme/tokens'
// The page surface, header, and footer live in the shared @components/PublicPage
// shell (PublicShell); loading/unavailable states in the shared state pair.

export const Container = styled.main`
	width: 100%;
	/* The shared content column — the SiteHeader aligns to this same width and
	   36px gutter (see theme/layout contentShell). */
	max-width: ${contentWidth};
	margin: 0 auto;
	padding: 40px 36px 64px;

	/* The single-column stack uses 18px gutters per the handoff (m-pad). */
	@media (max-width: ${breakpoints.bentoCollapse}px) {
		padding: 24px 18px 48px;
	}

	/* Phone: safe-area insets on the sides/bottom so a full-bleed notch /
	   home-indicator never clips content. */
	@media (max-width: ${breakpoints.phone}px) {
		padding: 16px max(18px, env(safe-area-inset-right)) max(40px, env(safe-area-inset-bottom))
			max(18px, env(safe-area-inset-left));
	}
`
